import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    agree: 'Accept and continue',
    text: 'Please take a few minutes to review the information regarding the insurance included in your Shine {0} package.',
    title: 'Insurance included in your\nShine {0} package',
    warningText:
      'Shine Business will soon be **{0} per month**. This price change matches the launch of new features: access and cards for your team, accounting access, etc.',
    warningTitle: 'Information about Shine Business',
  },
  fr: {
    agree: 'Accepter et continuer',
    text: 'Prenez quelques minutes pour consulter les informations relatives aux assurances incluses dans votre offre Shine {0}.',
    title: 'Assurances incluses dans votre offre Shine {0}',
    warningText:
      'L’offre Shine Business passera bientôt à **{0} par mois**. Ce changement de tarif accompagne le lancement de nouvelles fonctionnalités : accès restreints et cartes pour votre équipe, accès comptable, assurances additionnelles...',
    warningTitle: '**Information concernant l’offre Shine Business** \n',
  },
} as const);
